module.exports = __webpack_public_path__ + "static/img/xuanzhongdonghua.png@2x.8d66780a.png";